import * as Sentry from "@sentry/react";

export const useSentryCaptureException = (
  exception: unknown,
  hint?: any
): string => {
  return Sentry.captureException(exception, hint);
};
